// Deep-link do Check-in Diário: `?open=checkin-diario`.
//
// Quem lê é o layout, pra ABRIR o modal quando o parâmetro chega na URL. A lista
// de grafias mora aqui, e não inline lá, porque ela é contrato com o CMS (os
// links são preenchidos à mão) e porque já houve um segundo leitor: o menu
// horizontal escondia o item de quem não era elegível e precisava reconhecer o
// mesmo link. Essa regra saiu — hoje o inelegível vê o item e recebe a resposta
// ao abrir —, e com ela saiu o `isDailyCheckinDeepLink`, que testava a URL do CMS.

// Grafias aceitas. Canônico p/ divulgar: `checkin-diario`; as outras funcionam
// como alias por conveniência (o CMS do menu é preenchido à mão).
export const DAILY_CHECKIN_QUERY_VALUES = [
  'checkin-diario',
  'check-in-diario',
  'checkin',
];

// Valor do `?open=` da rota atual (que no Vue Router pode vir como array quando
// o parâmetro aparece repetido).
export function isDailyCheckinOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return (
    typeof first === 'string' && DAILY_CHECKIN_QUERY_VALUES.includes(first)
  );
}
